import { API } from "../../constant/apiConstant";

export const TicketService = {
  getUserTickets: async (token) => {
    try {
      const response = await fetch(`${API.BASE_URL}/api/tickets/`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const json = await response.json();
      return json;
    } catch (error) {
      console.error("Error fetching wallet data:", error);
      throw error;
    }
  },
  purchaseWithWallet: async ({ draw_id, quantity, client_request_id }) => {
    try {
      const response = await fetch(`${API.BASE_URL}/api/tickets/purchase/wallet`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          draw_id,
          quantity,
          client_request_id
        })
      });

      const json = await response.json();
      return {
        ok: response.ok,
        ...json
      };
    } catch (error) {
      console.error("Error purchasing tickets with wallet:", error);
      throw error;
    }
  }
};
